import React, { FC, useState, useEffect } from 'react';
import { useStore } from 'hooks/useRootStore';
import { useAppPreloader } from 'hooks/useAppPreloader';
import { useMutation } from 'react-query';
import { useForm, Controller } from 'react-hook-form';
import {
  Paper,
  Grid,
  Container,
  Button,
  TextField,
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
} from '@material-ui/core';
// import MuiPhoneNumber from 'material-ui-phone-number-2';
import { useStyles } from './styles';
import { ReactComponent as LogoIcon } from 'assets/logo.svg';
import { UserFormInputPattern, ClientRegisterData, GenericFormProps } from './types';
import { observer } from 'mobx-react-lite';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { useHistory } from 'react-router-dom';
export const ClientRegisterForm: FC<GenericFormProps> = observer(() => {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showPasswordConfirm, setShowPasswordConfirm] = useState<boolean>(false);
  const [mail, setMail] = useState('');
  const [userpassword, setUserpassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  // const [domain, setDomain] = useState('');
  const history = useHistory();
  const [focused] = useState<any>({ type: '', isfocused: false });
  const [emailValid, setEmailValid] = useState<any>(true);
  const [loginUrl, setLoginUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const handleEmailValidation = (e: any, type: string) => {
    const reg = new RegExp(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/);
    if (type === 'mail') {
      setEmailValid(reg.test(e.target.value));
    }
  };

  const {
    userStore: { register },
    notificationStore: { openNotification },
  } = useStore();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const hostname = window.location.hostname;
        const parts = hostname.split('.');
        const currentSubdomain = parts.length > 1 && hostname !== 'localhost' ? parts[0] : '';

        const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}auth/google-registration/redirect-url`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            fqdn: currentSubdomain || 'googleAuth',
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
        const contentType = response.headers.get('Content-Type');
        if (contentType && contentType.includes('application/json')) {
          const responseData = await response.json();
          setLoginUrl(responseData?.url || null);
          setLoading(false);
        } else {
          const responseData = await response.text();
          setLoginUrl(responseData);
          setLoading(false);
        }
      } catch (error) {
        setLoading(false);
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  const createUserReq = useMutation((data: ClientRegisterData) => register(data), {
    mutationKey: 'createUserReq',
    onSuccess: () => {
      openNotification(
        'success',
        'Thank you for signing up. Your account is currently being activated. This process usually takes up to 5 minutes. You’ll receive an email notification once activation is complete.'
      );
      setTimeout(() => {
        history.push('/dashboard');
      }, 3000);
    },
    onError: ({ message }: Error) => openNotification('error', message),
  });

  const passwordRegex = /(?=.*[A-Z].*[A-Z])(?=.*[a-z].*[a-z].*[a-z])(?=.*\d)(?=.*[!@#$%^&*()_-].*[!@#$%^&*()_-].*)/;
  const isStrongPassword = (password: any) => {
    return passwordRegex.test(password);
  };
  const { control, handleSubmit } = useForm<ClientRegisterData>();

  const onSubmit = (data: ClientRegisterData) => {
    const newData = {
      ...data,
    };
    return createUserReq.mutate(newData);
  };
  const mockDataPers1: UserFormInputPattern[] = [
    { label: 'Work Email', key: 'email', required: true },
    // { label: 'Re-type Work Email', key: 'email_confirmation', required: true },
    { label: 'Password', type: 'password', key: 'password', required: true },
    { label: 'Re-type Password', type: 'password', key: 'password_confirmation', required: true },
    // {
    //   label: 'Hostname(FQDN)',
    //   key: 'hostname',
    //   required: true,
    //   placeholder: 'Hostname(FQDN)',
    // },
    {
      key: 'first_name',
      label: 'First Name',
      required: true,
      pattern: {
        regexp: /^[A-Za-z]+$/,
        errorMessage: 'Only alphabets are allowed in First Name',
      },
    },
    {
      key: 'last_name',
      label: 'Last Name',
      required: true,
      pattern: {
        regexp: /^[A-Za-z]+$/,
        errorMessage: 'Only alphabets are allowed in Last Name',
      },
    },
    { key: 'domain', label: 'Domain', required: true },
    { key: 'organization_name', label: 'OrganisationName', required: true },
    { key: 'phone', label: 'Phone', required: true },
  ];

  useAppPreloader(createUserReq.isLoading || loading);

  return (
    <>
      <React.Fragment>
        <Grid item className={classes.container}>
          <div className={classes.topBar}>
            <LogoIcon style={{ marginLeft: '40px', width: '140px', height: '52px' }} />
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className={classes.box}>
            <Grid container justify='center'>
              <Paper className={classes.paper}>
                {/* <h1 className={classes.boxTitle} style={{ marginBottom: '30px', fontSize: '28px', fontWeight: 600 }}>Create Account</h1> */}

                <h1
                  className={classes.boxTitle}
                  style={{
                    marginBottom: '30px',
                    fontSize: '28px',
                    fontWeight: 600,
                  }}
                >
                  Create Account
                </h1>
                {loginUrl && loginUrl !== '' && (
                  <>
                    <Button
                      fullWidth
                      variant='outlined'
                      style={{
                        height: '48px',
                        marginBottom: '20px',
                        textTransform: 'none',
                        fontSize: '16px',
                        fontWeight: 500,
                        borderColor: '#dadce0',
                      }}
                    >
                      <img
                        src='https://developers.google.com/identity/images/g-logo.png'
                        alt='Google'
                        style={{
                          width: '20px',
                          height: '20px',
                          marginRight: '10px',
                        }}
                      />
                      <a href={loginUrl}>Sign in with Google</a>
                    </Button>
                    <span className={classes.titles} style={{ marginBottom: '20px' }}>
                      OR
                    </span>
                  </>
                )}
                <Grid container>
                  <Container className={classes.tableBox}>
                    {mockDataPers1.map((item, index) => (
                      <Controller
                        key={item.key}
                        name={item.key}
                        control={control}
                        rules={{
                          required: item?.required,
                          ...(item.pattern && {
                            pattern: { value: item.pattern.regexp, message: item.pattern.errorMessage },
                          }),
                        }}
                        render={({ field, fieldState: { invalid, error } }) => (
                          <Grid key={index} container className={item?.multiline ? classes.rowWide : classes.row}>
                            {item.type === 'password' ? (
                              <FormControl className={invalid ? classes.inputError : classes.input} required>
                                <InputLabel variant='outlined' htmlFor={item?.key}>
                                  {item.label}
                                </InputLabel>
                                <OutlinedInput
                                  {...field}
                                  error={invalid || userpassword !== confirmPassword}
                                  id={item?.key}
                                  label={item?.label}
                                  fullWidth
                                  value={field.value}
                                  onChange={(e) => {
                                    field.onChange(e);
                                    item?.key === 'password'
                                      ? setUserpassword(e.target.value)
                                      : item?.key === 'password_confirmation'
                                      ? setConfirmPassword(e.target.value)
                                      : console.log('failed to get password');
                                  }}
                                  required={item?.required}
                                  type={
                                    item?.key === 'password'
                                      ? showPassword
                                        ? 'text'
                                        : 'password'
                                      : showPasswordConfirm
                                      ? 'text'
                                      : 'password'
                                  }
                                  endAdornment={
                                    <InputAdornment position='end'>
                                      <IconButton
                                        aria-label='toggle password visibility'
                                        onClick={() =>
                                          item?.key === 'password'
                                            ? setShowPassword(!showPassword)
                                            : setShowPasswordConfirm(!showPasswordConfirm)
                                        }
                                      >
                                        {item?.key === 'password' ? (
                                          showPassword ? (
                                            <Visibility />
                                          ) : (
                                            <VisibilityOff />
                                          )
                                        ) : showPasswordConfirm ? (
                                          <Visibility />
                                        ) : (
                                          <VisibilityOff />
                                        )}
                                      </IconButton>
                                    </InputAdornment>
                                  }
                                />
                                {userpassword !== confirmPassword ? (
                                  <FormHelperText error id={item?.key}>
                                    Confirm Password does not match
                                  </FormHelperText>
                                ) : !isStrongPassword(userpassword) ? (
                                  <FormHelperText error id={item?.key}>
                                    Password must contain 2 uppercase,3 lowercase,2 special characters and 1 numerical
                                    value
                                  </FormHelperText>
                                ) : null}
                              </FormControl>
                            ) : item?.key === 'email' ? (
                              <TextField
                                {...field}
                                autoFocus={item?.autoFocus}
                                variant='outlined'
                                className={emailValid ? classes.inputError : classes.input}
                                multiline={item?.multiline}
                                label={item?.label}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                value={field.value}
                                onChange={(e) => {
                                  setMail(e.target.value);
                                  handleEmailValidation(e, 'mail');
                                  field.onChange(e);
                                }}
                                required
                                rows={item?.multiline ? 4 : 1}
                                placeholder={item.placeholder}
                                type={item.type ? item.type : undefined}
                                error={!emailValid || item.key === focused.type}
                                helperText={
                                  !emailValid && item.key === 'email' && mail !== ''
                                    ? 'Please enter valid email address'
                                    : invalid
                                    ? error?.type === 'pattern'
                                      ? item.pattern?.errorMessage
                                      : 'Required field'
                                    : ' '
                                }
                              />
                            ) : item?.key === 'first_name' || item?.key === 'last_name' ? (
                              <TextField
                                {...field}
                                autoFocus={item?.autoFocus}
                                variant='outlined'
                                className={invalid ? classes.inputError : classes.input}
                                multiline={item?.multiline}
                                label={item?.label}
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                value={field.value}
                                onChange={(e) => {
                                  field.onChange(e);
                                }}
                                required
                                rows={item?.multiline ? 4 : 1}
                                placeholder={item.placeholder}
                                type={item.type ? item.type : undefined}
                                error={invalid}
                                helperText={
                                  invalid
                                    ? error?.type === 'pattern'
                                      ? item.pattern?.errorMessage
                                      : 'Required field'
                                    : ' '
                                }
                              />
                            ) : (
                              <FormControl className={item.type === 'checkbox' ? classes.inputError : classes.input}>
                                <>
                                  {!item.type ? (
                                    <>
                                      <TextField
                                        {...field}
                                        className={invalid ? classes.inputError : classes.input}
                                        variant='outlined'
                                        fullWidth
                                        autoFocus={item?.autoFocus}
                                        label={item.label}
                                        placeholder={item.placeholder}
                                        error={invalid}
                                        onChange={(e) => {
                                          field.onChange(e);
                                        }}
                                      />
                                      {invalid ? (
                                        <FormHelperText error>
                                          {error?.type === 'validate' ? 'no validated' : ''}
                                          {error?.type === 'pattern' ? item?.pattern?.errorMessage : ''}
                                          {error?.type === 'required' ? 'Required field' : ''}
                                        </FormHelperText>
                                      ) : null}
                                    </>
                                  ) : null}
                                </>
                              </FormControl>
                            )}
                          </Grid>
                        )}
                      />
                    ))}
                  </Container>
                  <Button
                    type='submit'
                    disabled={!emailValid || userpassword !== confirmPassword}
                    className={classes.button}
                    variant='contained'
                    color='primary'
                  >
                    SUBMIT
                  </Button>
                </Grid>
              </Paper>
            </Grid>
          </form>
        </Grid>
      </React.Fragment>
    </>
  );
});
